<template>
    <div>
        <div class="content-header row">
            <div class="content-header-left col-md-9 col-12 mb-2">
                <div class="row breadcrumbs-top">
                    <div class="col-12">
                        <h2 class="content-header-title float-left mb-0">Mes souscriptions</h2>
                    </div>
                </div>
            </div>
        </div>
        <div class="content-body">
            <div class="row">
                <div class="col-md-12">
                    <div class="card">
                        <div class="card-body">
                            <all-subscription ref="all" />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import AllSubscription from "./item/meAll";
    export default {
        components: { AllSubscription },
        data: () => ({
            subscriptions: {},
            saveSubscriptions: {},
            step: 1,
            query:{
                namespace: 'all',
                per: 10,
                page: 1,
                product: ''
            }
        }),

        methods: {
            changeStatus(){
                this.$refs.all.makeFilter(this.query);
            }
        }
    }
</script>
